/* eslint-disable */
/**
 * Neptune TP API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddVideoCommand
 */
export interface AddVideoCommand {
    /**
     * 
     * @type {string}
     * @memberof AddVideoCommand
     */
    mediaCategoryId: string;
    /**
     * 
     * @type {string}
     * @memberof AddVideoCommand
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AddVideoCommand
     */
    fileUploadId: string;
}

export function AddVideoCommandFromJSON(json: any): AddVideoCommand {
    return {
        'mediaCategoryId': json['mediaCategoryId'],
        'name': json['name'],
        'fileUploadId': json['fileUploadId'],
    };
}

export function AddVideoCommandToJSON(value?: AddVideoCommand | null): any {
    if (value == undefined) {
        return undefined;
    }
    return {
        'mediaCategoryId': value.mediaCategoryId,
        'name': value.name,
        'fileUploadId': value.fileUploadId,
    };
}


